<template lang="pug">
vm-row.heading(vm-w="12")
  modal-reports-rse(:form="form" :isAdd="isModalAdd")
  vm-col.mb-3(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
    div
      h2 {{ $t('strings.reports_rse') }}:
      span {{ $t('strings.description', {attribute: $t('strings.reports_rse')}) }}
    div(style="display:none;")
      vm-button(type="default" icon="list")
      vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
  vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
    div
      vm-button(icon="plus" @click="addRecord") {{ $t('strings.add') }}
  vm-row(vm-w="12")
    vm-col.card(vm-sm=12)
      vm-table(v-model="selected"  max-height="350px" :data="reportsRse")
        template(slot="thead")
          vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('reports_rse.' + column) }}
        template(slot-scope="{data}")
          vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
            vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
              slot(v-if="column == 'text'")  {{JSON.parse(data[indextr][column]).es}}
            vm-td
            vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
              vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
              vm-dropdown-menu
                vm-dropdown-item.d-flex.justify-content-between(@click="editRecord(data[indextr], tr)")
                  vm-icon(icon="edit-2-outline")
                  slot &nbsp;{{ $t('strings.edit') }}
                vm-dropdown-item.d-flex.justify-content-between(@click="deleteRecordConfirm(data[indextr], tr)")
                  vm-icon(icon="trash-2-outline")
                  slot &nbsp;{{ $t('strings.delete') }}
                //- More actions
      vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('ReportsRse')
const ModalReportsRse = () => import('@/components/modals/ModalReportsRse.vue')
export default {
  name: 'VReportsRse',
  components: {
    ModalReportsRse
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    columns: ['text'],
    currentPage: 1,
    form: {},
    attributeModal: 'url',
    isModalAdd: true
  }),
  computed: {
    ...mapGetters(['reportsRse', 'pagination'])
  },
  watch: {
    currentPage (currentPage) {
      this.loadRecords({ page: currentPage })
    }
  },
  async created () {
    await this.loadRecords({ page: this.currentPage })
  },
  methods: {
    ...mapActions(['loadRecords', 'setModalVisible', 'deleteRecord']),
    addRecord () {
      this.form = {
        text: {
          es: '',
          en: ''
        }
      }
      this.isModalAdd = true
      this.setModalVisible(true)
    },
    editRecord (data) {
      this.form = {
        ...data,
        text: JSON.parse(data.text)
      }
      this.isModalAdd = false
      this.setModalVisible(true)
    }
  }
}
</script>

<style>

</style>
